import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'

const service: AppRouteModule = {
  path: '/setting',
  name: 'Setting',
  component: LAYOUT,
  redirect: '',
  meta: {
    icon: 'icon-shezhi',
    title: '系统设置',
  },
  children: [
    {
      path: '/setting/reset',
      name: 'SettingReset',
      component: () => import('/@/views/setting/reset.vue'),
      meta: {
        title: '重置密码',
        code: '',
      },
    },
    {
      path: '/setting/groups',
      name: 'SettingGroups',
      component: () => import('/@/views/setting/groups.vue'),
      meta: {
        title: '分组管理',
        code: 'B030101',
      },
    },
    {
      path: '/setting/user/scheduling',
      name: 'UsersScheduling',
      component: () => import('/@/views/setting/user/scheduling.vue'),
      meta: {
        title: '排班',
        code: 'B030201',
        hideMenu: true,
        belong: '/staff/user',
        noKeepAlive: true,
      },
    },
    {
      path: '/setting/user/schedulingDetail',
      name: 'UsersSchedulingDetail',
      component: () => import('/@/views/setting/user/schedulingDetail.vue'),
      meta: {
        title: '查看排班',
        code: 'B030201',
        hideMenu: true,
        belong: '/staff/user',
        noKeepAlive: true,
      },
    },
    {
      path: '/setting/shortcutKey',
      name: 'SettingShortcutKey',
      component: () => import('/@/views/setting/shortcutKey.vue'),
      meta: {
        title: '高级设置',
        code: '',
      },
    },
  ],
}

export default service
